export default {
  isMobile: () => {
    const ua = navigator.userAgent

    const isIphone = ua.match(/(iPhone\sOS)\s([\d_]+)/)
    const isAndroid = ua.match(/(Android)\s+([\d.]+)/)

    return isIphone || isAndroid
  }
}
